import { Box } from '@chakra-ui/react'
import ManagedDrawer from '@components/common/drawer/managed-drawer'
import ManagedModal from '@components/common/modal/managed-modal'
import OfferBar from '@components/common/offer-bar'
import { Footer } from '@components/layout/Footer'
import MobileNavigation from '@components/layout/mobile-navigation/mobile-navigation'

const Layout: React.FC<any> = ({ children }) => {
  return (
    <>
      <Box
        sx={{
          '.bg-skin-fill': { bg: 'primary.100' },
          '.text-skin-base': { color: 'black' },
          '.hover:text-skin-primary': { color: 'blue' },
        }}
        className="flex flex-col min-h-screen "
      >
        <OfferBar />
        <main
          className="relative flex-grow"
          style={{
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <>{children}</>
        </main>
        <Footer />
        <ManagedModal />
        <ManagedDrawer />
        <MobileNavigation />
      </Box>
    </>
  )
}

Layout.displayName = 'Generic Layout'
export default Layout
